import Information from "./SVG/information-circle.svg?react";

const InformationIcon = () => {
  return <Information />;
};

export default InformationIcon;
